import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "overflow-auto" }
const _hoisted_2 = { class: "table table-striped table-sm" }
const _hoisted_3 = { class: "text-capitalize-first" }
const _hoisted_4 = { class: "text-capitalize-first" }
const _hoisted_5 = { class: "text-capitalize-first" }
const _hoisted_6 = { class: "d-flex flex-column mt-1 mb-1" }
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "text-secondary" }
const _hoisted_9 = { class: "text-secondary" }
const _hoisted_10 = { class: "text-secondary" }
const _hoisted_11 = {
  class: "align-top",
  style: {"max-width":"500px"}
}
const _hoisted_12 = { style: {"white-space":"pre-line"} }
const _hoisted_13 = {
  class: "align-top",
  style: {"max-width":"500px"}
}
const _hoisted_14 = { style: {"white-space":"pre-line"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.helper.trans('labels.show_request_log'),
    "dialog-class": "modal-xxl",
    modelValue: _ctx.modal,
    "footer-class": "d-flex justify-content-end",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.modal = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_LoaderWrapper, { ref: "requestModalLoader" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("table", _hoisted_2, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t('labels.id')), 1),
                  _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('labels.request')), 1),
                  _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('labels.response')), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logs.items, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("span", null, [
                          _withDirectives((_openBlock(), _createElementBlock("span", {
                            title: item.invoiceId
                          }, [
                            _createTextVNode(_toDisplayString(item.invoiceId.substring(0, 8)) + "...", 1)
                          ], 8, _hoisted_7)), [
                            [
                              _directive_b_tooltip,
                              void 0,
                              void 0,
                              { hover: true }
                            ]
                          ]),
                          _cache[2] || (_cache[2] = _createTextVNode()),
                          _createVNode(_component_copy_button, {
                            value: item.invoiceId
                          }, null, 8, ["value"])
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("small", _hoisted_8, _toDisplayString(_ctx.dateHelper.format(item.requestAt, 'YYYY-MM-DD')), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("small", _hoisted_9, _toDisplayString(_ctx.dateHelper.format(item.requestAt, 'HH:mm:ss')), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("small", _hoisted_10, _toDisplayString(_ctx.dateHelper.format(item.responseAt, 'HH:mm:ss')), 1)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_11, [
                      _createElementVNode("pre", null, [
                        _createElementVNode("code", _hoisted_12, "\n                      " + _toDisplayString(item.requestMethod) + "\n\n                      BODY\n                      " + _toDisplayString(item.request) + "\n                    ", 1)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_13, [
                      _createElementVNode("pre", null, [
                        _createElementVNode("code", _hoisted_14, "\n                    CODE: " + _toDisplayString(item.responseCode) + "\n\n                    BODY\n                    " + _toDisplayString(item.response) + "\n                    ", 1)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]),
        _: 1
      }, 512)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.modal = false), ["prevent"])),
        class: "btn btn-outline-dark btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.helper.trans('button.close')), 1)
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}